import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Fab, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AppLayout } from '../components/AppLayout';
import { BookingsCalendar } from '../components/BookingsCalendar';
import { colors } from '../theme';

export function CalendarPage() {
  return (
    <AppLayout
      title="Calendario sede"
      maxWidth="lg"
      floating={
        <Fab
          component={RouterLink}
          to="/prenota"
          variant="extended"
          color="primary"
          aria-label="Prenota la sede"
          sx={{
            position: 'fixed',
            right: { xs: 16, sm: 28 },
            bottom: { xs: 20, sm: 28 },
            zIndex: (t) => t.zIndex.speedDial,
            px: 2.75,
            gap: 0.75,
            boxShadow: `0 4px 16px ${colors.primary}55`,
            '&:hover': {
              boxShadow: `0 6px 20px ${colors.primary}66`,
            },
          }}
        >
          <AddIcon />
          Prenota
        </Fab>
      }
    >
      <Stack spacing={{ xs: 2, sm: 3 }} sx={{ pb: 10 }}>
        <Box sx={{ px: { xs: 0.5, sm: 0 } }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: colors.primary,
              fontSize: { xs: '1.5rem', sm: '2rem' },
              letterSpacing: '-0.02em',
            }}
          >
            Calendario prenotazioni
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 1, maxWidth: 520, lineHeight: 1.5 }}
          >
            Prenotazioni approvate.
          </Typography>
        </Box>

        <BookingsCalendar />
      </Stack>
    </AppLayout>
  );
}
